if ($('.js-top-nav').data('template') === 'horizontal-multilevel-3') {
	var menu = {
		itemsFirstLevel: $('.js-top-item-lvl1'), //элементы в меню первого уровня
		amountItemsFirstLevel: $('.js-top-item-lvl1').length, //колличество элементов меню первого уровня
		colspanSecondLevel: 2 //колличество колонок коротое занимает по ширине меню второго уровня
	};

	function menuTopBuild() {
		if (menu.amountItemsFirstLevel < (menu.colspanSecondLevel - 1) * 2) {
			console.error('Menu: Привышенно максимальное значение colspanSecondLevel');
		}
		//menu.itemsFirstLevel.css('width', 100 / menu.amountItemsFirstLevel + '%')
		$('.js-top-list-lvl2').css('width', 100 * menu.colspanSecondLevel + '%');
		$('.js-top-item-lvl2').has('.js-top-list-lvl3').addClass('has-submenu');
		$('.js-top-item-lvl3').has('.js-top-list-lvl4').addClass('has-submenu');
		$.each(menu.itemsFirstLevel, function (index) {
			if (index > (menu.amountItemsFirstLevel - menu.colspanSecondLevel)){
				$(menu.itemsFirstLevel[index])
					.find('.js-top-list-lvl2')
					.css({
						left: 'inherit',
						right: '100%'
					});
			}
			if (index > (menu.amountItemsFirstLevel - menu.colspanSecondLevel * 2)){
				$(menu.itemsFirstLevel[index])
					.find('.js-top-list-lvl2')
					.addClass('submenu-slide-right')
					.find('.js-top-list-lvl3')
					.addClass('is-slide-right')
					.css({
						left: 'inherit',
						right: '100%'
					});
			}
		});
	};

	if ($.fn.velocity){
		$('.js-top-link').on('click touchstart', function (event) {
			var $this = $(this),
					lvl = 1;
			if ($this.hasClass('js-top-link-lvl2')) {
				lvl = 2;
			} else if ($this.hasClass('js-top-link-lvl3')) {
				lvl = 3;
			} else if ($this.hasClass('js-top-link-lvl4')) {
				lvl = 4;
			}
			openTopMenu ($this, lvl, event);
		});

		function openTopMenu(element, lvl, ev) {
			var $this = element;
			if (lvl === 1) {
				var showEffect = 'transition.slideDownIn';
			} else if ($this.siblings('.is-slide-right').length) {
				var showEffect = 'transition.slideRightIn';
			} else {
				var showEffect = 'transition.slideLeftIn';
			}
			if (!$this.hasClass('is-expand') && $this.parents('.js-top-item-lvl' + lvl).has('.js-top-list-lvl' + (lvl + 1)).length) {
				ev.preventDefault();
				$('.js-top-link-lvl' + lvl + '.is-expand')
					.removeClass('is-expand')
					.siblings('.nav__list')
					.velocity('transition.fadeOut', 200)
					.find('.is-expand')
					.removeClass('is-expand')
					.siblings('.nav__list')
					.velocity('transition.fadeOut', 200);
				$this
					.addClass('is-expand')
					.siblings('.nav__list')
					.velocity(showEffect, 200);
			} else {
				$('.is-expand')
					.removeClass('is-expand')
					.siblings('.nav__list')
					.velocity('transition.slideUpOut', 200);
			}
		};

		$(document).on('click', function (event) {
			if (!$(event.target).closest('.js-top-nav').length) {
				$('.js-top-nav .is-expand')
					.removeClass('is-expand')
					.siblings('.nav__list')
					.velocity('transition.slideUpOut', 200);
			}
		});
	} else {
		console.error('Menu: Для работы меню необходимо подключить VelocityJS и VelocityJS UI Pack');
	}
	menuTopBuild();
}



/** WEBPACK FOOTER **
 ** ./frontend/components/menu/horizontal-multilevel-3/horizontal-multilevel-3.js
 **/